import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { ErrorService } from '../helpers/errorService';
import { IRMSRecordReview } from '../models/rmsRecordReview';

@Injectable({
  providedIn: 'root'
})
export class RMSRecordReviewService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getRmsRecordReviewByCaseId(caseId: string): Observable<IRMSRecordReview> {
        const url = environment.apiBaseUrl + endpoints.getRMSRecordReviewByCaseId.replace(':caseId', caseId);
        return this.http.get<IRMSRecordReview>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    updateRmsRecordReview(data: IRMSRecordReview): Observable<any> {
        const url = environment.apiBaseUrl + endpoints.updateRMSRecordReview;
        return this.http.post(url, data).pipe(
            catchError(this.errorService.handleSavingError)
        );
    }
}